import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
type ChipProps = {
  label?: string;
  value: string;
  toggleOption: (value: string) => void;
};
const Chip = t0 => {
  const $ = _c(15);
  const {
    label,
    value,
    toggleOption
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.multi-select"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("ui", t1);
  let t2;
  if ($[1] !== label) {
    t2 = <p className="truncate text-body-2 text-primary">{label}</p>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("clear-aria-label-default");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== toggleOption || $[6] !== value) {
    t4 = event => {
      event.preventDefault();
      event.stopPropagation();
      toggleOption(value);
    };
    $[5] = toggleOption;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IcoCloseSmall16 color="tertiary" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4) {
    t6 = <div aria-label={t3} className="flex items-center justify-center w-4 h-4 rounded-sm cursor-pointer focus-visible:outline-none focus-visible:bg-hover-control hover:bg-hover-control" onClick={t4} onKeyDown={_temp}>{t5}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = <div className="flex items-center h-6 px-1 pr-0.5 border rounded-sm bg-primary border-primary text-primary gap-0.5">{t2}{t6}</div>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default Chip;
function _temp(event_0) {
  if (event_0.key === "Enter" || event_0.key === " ") {
    event_0.stopPropagation();
  }
}